export default __webpack_public_path__ + "images/nc-5681de45e8340741e312252970a01037.svg";